import React from 'react';
import { Grid, Typography, Card } from '@material-ui/core';
import { HoverText } from '@campfire/hover-link';
import { TitularTooltip } from '@campfire/titular-tooltip/lib';
import { useFormBuilderDialogContext } from '../FormBuilderDialogContext';
import { useCampfireTheme } from '../../../../../theme/useCampfireTheme';
import { GetForm_vm_form_formItems_VOLUNTEER_FormItemFieldType as FieldFormItemType } from '../../__generated__/GetForm';
import { FieldFormItemTitle } from './field-form-items/FieldFormItemTitle';
import { FormItemField } from './field-form-items/FormItemField';
import { FormListItemContext } from '../FormListItemContext';

interface Props {
  data: FieldFormItemType;
}

export const FieldFormItem = (props: Props) => {
  const { data } = props;
  const { editField } = useFormBuilderDialogContext();
  const { theme } = useCampfireTheme();
  const { draggingId } = React.useContext(FormListItemContext);

  return (
    <Card
      elevation={0}
      style={{
        padding: 16,
        marginBottom: 8,
        width: '100%',
        border: `1px solid ${theme.color.grey.border}`,
      }}
    >
      <Grid container spacing={1} style={{ padding: 8 }}>
        <FieldFormItemTitle __typename={data.field.__typename} name={data.field.name} optional={data.optional} />

        <HoverText color='primary' onClick={() => editField(data)}>
          {'Edit Field'}
        </HoverText>

        <TitularTooltip description={'Press and hold to reorder this field'}>
          <Grid item container>
            <Grid item xs={12}>
              <Typography color='textSecondary' variant='body2'>
                {data.field.description}
              </Typography>
            </Grid>

            <Grid item xs={10}>
              <FormItemField field={data.field} isDragging={data.formItemId === draggingId} />
            </Grid>
          </Grid>
        </TitularTooltip>
      </Grid>
    </Card>
  );
};
